export const WORK_SESSION_VIEW_BUTTON_LABEL = 'Submission Activity';
export const WORK_SESSION_MODAL_TITLE = 'Assignment work session';
export const WORK_SESSION_REFRESH_LABEL = 'Refresh';
export const WORK_SESSION_LOADING_LABEL = 'Loading work session';

export function getSubmissionActivityLogId(submission) {
    if (!submission || typeof submission !== 'object') return null;
    const meta = submission.meta_data;
    const candidate =
        submission.log_id ??
        submission.logId ??
        (meta && typeof meta === 'object' && !Array.isArray(meta) ? meta.log_id ?? meta.logId : null);
    if (candidate == null || candidate === '') return null;
    const s = String(candidate).trim();
    return s.length ? s : null;
}
